module.exports = __webpack_public_path__ + "static/media/homepage_white_section.9e8327fd.jpg";